<template>
	<div>
		<h4>Pola w grupie
			{{group.name}}</h4>
		<ol>
			<li v-for="(field, index) in group.fields"
				v-bind:key="index">
				{{ field.label }}
				<v-icon @click="moveFieldUp(index)" flat v-if="fieldCanBeMovedUp(index)">
					arrow_upward
				</v-icon>

				<v-icon @click="moveFieldDown(index)" flat
					v-if="fieldCanBeMovedDown(index)">
					arrow_downward
				</v-icon>
				<v-btn @click="editField(index)">Edytuj pole</v-btn>
				<v-icon @click="removeField(index)" flat>
					close
				</v-icon>
				<span v-if="isConditional(field)">CONDITIONAL</span>
			</li>
		</ol>
	</div>
</template>

<script>
	import {fieldTypes} from "../../../../../utils/FieldTypes";

	export default {
		name: "FieldList",

		props: {
			value: Object,
		},

		computed: {
			group: function () {
				return this.form.formSchema.sections[this.form.selected.sectionIndex].groups[this.form.selected.groupIndex];
			},

			section: function () {
				return this.form.formSchema.sections[this.form.selected.sectionIndex];
			},
		},

		watch: {
			form: {
				handler() {
					this.$emit("input", this.form);
				}
				,
				deep: true,
			},
		},

		data() {
			return {
				form: this.value,
			};
		},

		methods: {

			updateFieldList() {
				this.$forceUpdate();
			},

			isConditional(field) {
				return field.business === fieldTypes.CONDITIONAL;
			},

			fieldCanBeMovedUp(index) {
				return index !== 0;
			},


			fieldCanBeMovedDown(index) {
				return this.group.fields.length > 0 && index !== this.group.fields.length - 1;
			},

			moveFieldUp(index) {
				this.swapTwoArrayElements(this.group.fields, index - 1, index);
			},

			moveFieldDown(index) {
				this.swapTwoArrayElements(this.group.fields, index + 1, index);
			},


			editField(index) {
				let indexes = {
					sectionIndex: this.form.selected.sectionIndex,
					groupIndex: this.form.selected.groupIndex,
					fieldIndex: index,
				};
				this.$emit("editField", indexes);
			},

			removeField(index) {
				if (this.isConditional(this.group.fields[index])) {
					this.removeFinalGroups();
				}
				this.group.fields.splice(index, 1);
			},


			removeFinalGroups() {
				this.section.groups.splice(this.form.selected.groupIndex + 2, 1);
				this.section.groups.splice(this.form.selected.groupIndex + 1, 1);
			},

			swapTwoArrayElements(array, index1, index2) {
				// swap na dwóch elementach tablicy w ES6
				array = [array[index1], array[index2]] = [array[index2], array[index1]];
				this.$forceUpdate();
			},
		},
	};
</script>

<style scoped>

</style>
